import { useTranslation } from '@kostbar/i18n'
import type { NotOrderable } from '@/api/endpoints/purchase-orders'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'

/** "Nicht bestellbar" (design D12): rows the server could not turn into lines, each with its reason. */
export function NotOrderableList({ items }: { items: Array<NotOrderable> }) {
  const { t } = useTranslation('purchase-orders')
  if (items.length === 0) return null
  return (
    <Card className="overflow-hidden border-warning/50 pb-0">
      <CardHeader>
        <CardTitle>{t('notOrderable.title')}</CardTitle>
      </CardHeader>
      <CardContent className="p-0">
        <div className="hidden grid-cols-[minmax(10rem,1fr)_minmax(10rem,1fr)] gap-x-3 bg-muted/50 px-3 py-2 text-xs font-medium text-muted-foreground sm:grid">
          <div>{t('detail.column.article')}</div>
          <div>{t('notOrderable.reasonColumn')}</div>
        </div>
        {items.map((item) => (
          <div
            key={item.sku}
            className="grid grid-cols-1 gap-x-3 gap-y-1 border-t px-3 py-2 text-sm sm:grid-cols-[minmax(10rem,1fr)_minmax(10rem,1fr)] sm:items-center"
          >
            <div className="min-w-0">
              <p className="font-medium break-words">{item.name ?? item.sku}</p>
              <p className="font-mono text-xs text-muted-foreground">
                {item.sku}
              </p>
            </div>
            <p className="text-muted-foreground">
              {t(`notOrderable.reason.${item.reason}`)}
            </p>
          </div>
        ))}
      </CardContent>
    </Card>
  )
}
